<template>
	<div
		class="prose max-w-none prose-headings:text-lg prose-headings:text-highlighted prose-a:text-primary prose-a:underline [&_a]:hover:decoration-2 underline-offset-2 decoration-primary flex flex-col mt-10 space-y-4 text-default break-words"
		v-html="html"
	/>
</template>

<script setup lang="ts">
defineProps({
	html: {
		type: String,
		required: true
	}
})
</script>
